"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var SentenceBreakdownWrapper = function SentenceBreakdownWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      // DUPLICATED onPress and onClick
      _this.onPress = function (wordAssociation) {
        if ((0, _utils.isBlank)(wordAssociation)) {
          return;
        }
        if (_this.props.disableOnClick) {
          return;
        }
        if (!_this.props.disableUpdateSelectedWordAssociationId) {
          var selected = wordAssociation === null || wordAssociation === void 0 ? void 0 : wordAssociation.id;
          _this.props.sentence.state.set('selectedWordAssociationId', selected);
        }
        if (!_this.props.multipleSelections) {
          _this.props.sentence.state.set('blockHighlight', _this.props.blockHighlightOnClick);
        }
        if (_this.props.onOpenArrowBox) {
          _this.props.onOpenArrowBox();
        }
        if (_this.props.onPress) {
          _this.props.onPress(wordAssociation);
        }
      };
      _this.onClick = function (wordAssociation) {
        if ((0, _utils.isBlank)(wordAssociation)) {
          return;
        }
        if (_this.props.disableOnClick) {
          return;
        }
        if (!_this.props.disableUpdateSelectedWordAssociationId) {
          var selected = wordAssociation === null || wordAssociation === void 0 ? void 0 : wordAssociation.id;
          _this.props.sentence.state.set('selectedWordAssociationId', selected);
        }
        if (!_this.props.multipleSelections) {
          _this.props.sentence.state.set('blockHighlight', _this.props.blockHighlightOnClick);
        }
        if (_this.props.onOpenArrowBox) {
          _this.props.onOpenArrowBox();
        }
        if (_this.props.onClick) {
          _this.props.onClick(wordAssociation);
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "cursor",
      get: function get() {
        return this.props.disableOnClick ? 'default' : this.props.cursor || 'pointer';
      }
    }, {
      key: "wordAssociations",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.sentence) && (0, _utils.isPresent)(this.props.sentence.wordAssociations)) {
          var reverseText = _state.AppUI.layout.isNative && _state.AppUI.user.mobileTextDirection === 'reverse' || !_state.AppUI.layout.isNative && this.props.sentence.rightToLeftLanguage || _state.AppUI.layout.isNative && this.props.sentence.rightToLeftLanguage && _state.AppUI.user.mobileTextDirection !== 'forward';
          return reverseText ? this.props.sentence.wordAssociations.slice().reverse() : this.props.sentence.wordAssociations;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onPress: this.onPress,
          onClick: this.onClick,
          wordAssociations: this.wordAssociations,
          cursor: this.cursor
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "cursor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cursor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordAssociations"), _class2.prototype), _class2)) || _class;
};
SentenceBreakdownWrapper.displayName = 'SentenceBreakdownWrapper';
var _default = exports["default"] = SentenceBreakdownWrapper;